import { attachmentUrl } from '../api/attachment';
import { useImageLightbox } from './ImageLightboxContext';
import { useT } from '../I18nContext';

/**
 * Image attachments on user turns. Each id resolves via the
 * owner-only /api/attachment/<id> endpoint (Flask gates it on
 * the requesting user, so a stolen id from another tenant
 * 401s). Click → ImageLightbox opens at full-size.
 */
interface MessageAttachmentsProps {
  attachmentIds: string[];
}

export function MessageAttachments({ attachmentIds }: MessageAttachmentsProps) {
  const { open } = useImageLightbox();
  const t = useT();
  if (!attachmentIds.length) return null;
  return (
    <div className="message-attachments">
      {attachmentIds.map((aid) => {
        const url = attachmentUrl(aid);
        return (
          <button
            key={aid}
            type="button"
            className="message-attachment-btn"
            onClick={() => open(url)}
            aria-label={t('message_attachments.view_aria')}
            title={t('attach.view_full_size')}
          >
            <img
              className="message-attachment-thumb"
              src={url}
              alt={t('message_attachments.alt')}
              loading="lazy"
            />
          </button>
        );
      })}
    </div>
  );
}
